import type { TruncationMode } from '../../../../../../typography/text-ellipsis/TextEllipsis.js';
import { GAP_BETWEEN_LABELS, TEXT_ELLIPSIS } from '../constants.js';
import { getLabelsPosition, truncateLabel } from './labels-collision.js';

/**
 * Handle the collision between two labels (left and right boundary).
 * If a collision is detected it applies the truncation and return the
 * truncated labels.
 * @param firstLabel -
 * @param lastLabel -
 * @param truncationMode -
 * @param bounds -
 */
export const handleTwoLabelsCollisions = (
  firstLabel: string,
  lastLabel: string,
  truncationMode: TruncationMode,
  bounds: [number, number],
) => {
  const { startLabel, endLabel } = getLabelsPosition(
    firstLabel,
    lastLabel,
    bounds,
  );
  let iteration = 0;
  let startLabelEndPosition = startLabel.end;
  let endLabelStartPosition = endLabel.start;

  const isTruncationNeeded =
    startLabelEndPosition >= endLabelStartPosition - GAP_BETWEEN_LABELS;

  if (!isTruncationNeeded) {
    return { startLabel: firstLabel, endLabel: lastLabel };
  }
  let candidateStartLabel = firstLabel;
  let candidateEndLabel = lastLabel;

  do {
    candidateStartLabel = truncateLabel(candidateStartLabel, truncationMode);

    if (!candidateStartLabel.includes(TEXT_ELLIPSIS)) {
      break;
    }

    candidateEndLabel = truncateLabel(candidateEndLabel, truncationMode);

    if (!candidateEndLabel.includes(TEXT_ELLIPSIS)) {
      break;
    }
    const { startLabel: newStartLabel, endLabel: newEndLabel } =
      getLabelsPosition(candidateStartLabel, candidateEndLabel, bounds);

    startLabelEndPosition = newStartLabel.end;
    endLabelStartPosition = newEndLabel.start;
    iteration++;

    if (iteration >= Math.max(firstLabel.length, lastLabel.length)) {
      break;
    }
  } while (startLabelEndPosition + GAP_BETWEEN_LABELS >= endLabelStartPosition);

  return {
    startLabel: candidateStartLabel,
    endLabel: candidateEndLabel,
  };
};
